import React from 'react'
import { IconButton, Skeleton } from '@fs/zion-ui'
import { ControlExpand } from '@fs/zion-icon'
import ZionMap, { Marker } from '@fs/zion-map'
import { appConfig } from '@fs/zion-config'
import transl from './SearchResultsPageMiniMap.transl'

import { cssExpandButton, cssMiniMapWrapper } from './SearchResultsPageMiniMap.styles'

const { GOOGLE_MAPS_API_KEY } = appConfig

export default function SearchResultsPageMiniMap({
  allCountriesMode,
  currentPlace,
  location,
  markerCount,
  setMapOverlay,
  miniMapRef,
}) {
  const countTitle = markerCount > 1 ? ` ${transl.mapMarkerAriaLabel(markerCount, currentPlace?.fullName)}` : ''

  return (
    <div css={cssMiniMapWrapper}>
      <div css={cssExpandButton}>
        <IconButton
          color="gray"
          emphasis="lightHigh"
          Icon={ControlExpand}
          onClick={setMapOverlay}
          ref={miniMapRef}
          title={`${transl.openOverlay()}${countTitle}`}
        />
      </div>
      <ZionMap
        googleApiKey={GOOGLE_MAPS_API_KEY}
        initialLatitude={allCountriesMode ? 25 : location?.latitude}
        initialLongitude={allCountriesMode ? -25 : location?.longitude}
        initialZoom={allCountriesMode ? 1 : undefined}
        nonInteractive
      >
        {!allCountriesMode && (
          <Marker
            ariaLabel={transl.mapMarkerAriaLabel(markerCount, currentPlace?.fullName)}
            chars={markerCount}
            focused
            latitude={location.latitude}
            longitude={location.longitude}
          />
        )}
      </ZionMap>
    </div>
  )
}

export function SearchResultsPageMiniMapLoading() {
  return <Skeleton.Image width="100%" height="178px" />
}
